import { useFormContext } from "react-hook-form";
import { FormGroup, Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ValidationMessage from "../ValidationMessage";
import { EmailSuggestion, SuggestionButton } from "./ContactInfoForm.styles";

const Field = ({ field, suggestion = null, onApplySuggestion }) => {
  const { register } = useFormContext();
  const { onBlur, onChange, ...registerProps } = register(field.name);
  // Only a blocking typo (e.g. ".con") is an error; other suggestions are hints
  const isFlagged = field.hasError || suggestion?.blocking;
  return (
    <FormGroup controlId={field.name} className="mb-4">
      <Form.Label className={isFlagged ? "text-danger" : undefined}>
        {field.title}:{isFlagged && "*"}
      </Form.Label>
      <InputGroup>
        <InputGroup.Text
          className={isFlagged ? "bg-danger text-white" : undefined}
        >
          <FontAwesomeIcon icon={field.icon} />
        </InputGroup.Text>
        <Form.Control
          type={field.type}
          {...registerProps}
          {...field.inputProps}
          onChange={(event) => {
            onChange(event);
            field.onChange?.(event);
          }}
          onBlur={(event) => {
            onBlur(event);
            field.onBlur?.(event);
          }}
          placeholder={field.placeholder}
        />
      </InputGroup>
      <ValidationMessage message={field.hasError?.message} />
      {suggestion && (
        <EmailSuggestion
          className={suggestion.blocking ? "text-danger" : "text-secondary"}
        >
          Meinten Sie{" "}
          <SuggestionButton type="button" onClick={onApplySuggestion}>
            {suggestion.email}
          </SuggestionButton>
          ?
        </EmailSuggestion>
      )}
    </FormGroup>
  );
};
export default Field;
